var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',_vm._g(_vm._b({},'IconBase',_vm.$props,false),_vm.$listeners),[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"17","height":"17","rx":"5.5","stroke":"#7019FD"}})])}
var staticRenderFns = []

export { render, staticRenderFns }